var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _c("div", { staticClass: "nuv" }),
    _vm._v(" "),
    _c("div", { staticClass: "result-con" }, [
      _c("div", { staticClass: "count" }, [
        _c("h2", [_vm._v("考试结果")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "useTime" },
          [
            _vm.data.isCorrect == "no"
              ? [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("用时："),
                    _c("span", { staticClass: "blue" }, [
                      _vm._v(_vm._s(_vm.getTime(_vm.data.examTimeSpent)))
                    ])
                  ])
                ]
              : [
                  _c("p", [
                    _vm.data.isPassed == "passed"
                      ? _c("span", { staticClass: "result-txt" }, [
                          _vm._v("恭喜您已通过考试")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.isPassed == "failed"
                      ? _c("span", { staticClass: "result-txt" }, [
                          _vm._v("很遗憾您未通过考试")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("用时："),
                    _c("span", { staticClass: "blue" }, [
                      _vm._v(_vm._s(_vm.getTime(_vm.data.examTimeSpent)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("得分："),
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.data.tjkScore) + "分")
                    ])
                  ])
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.list, function(s) {
            return _c(
              "li",
              {
                class: {
                  active2: s.answerState == "right",
                  active4: s.answerState == "wrong",
                  active1: s.answerState == "halfRight"
                }
              },
              [_vm._v(_vm._s(s.num))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm._m(1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "result-txt" }, [
        _vm._v("请耐心等待批阅，考试结果会在消息中心公布")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "color-txt" }, [
      _c("span", { staticClass: "right" }, [_vm._v("正确")]),
      _c("span", { staticClass: "wrong" }, [_vm._v("错误")]),
      _c("span", { staticClass: "halfright" }, [_vm._v("部分正确")]),
      _c("span", { staticClass: "waitGrade" }, [_vm._v("待批阅")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23a3cbd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a3cbd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/examResult.vue
// module id = 1135
// module chunks = 0